import { render, staticRenderFns } from "./performanceManagement.vue?vue&type=template&id=b35ddf6e&scoped=true&"
import script from "./performanceManagement.vue?vue&type=script&lang=ts&"
export * from "./performanceManagement.vue?vue&type=script&lang=ts&"
import style0 from "./performanceManagement.vue?vue&type=style&index=0&id=b35ddf6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35ddf6e",
  null
  
)

export default component.exports